module.exports = __webpack_public_path__ + "img/OneHander.05fc7efd.png";